import { AuthUser } from "./AuthUser"
import BaseModel from "./BaseModels/BaseModel"

export default class Event extends BaseModel {
    constructor() {
        super()
        this.uuid = this.identifier ?? ""
    }
    organisation_uuid?: string
    source?: string
    resource?: string
    operation?: OperationEnum
    identifier?: string
    audit_event_date_time?: string
    user?: AuthUser
    audit_data?: auditData
    system_user?: boolean
}

export class auditData {
    before?: any
    after?: any
    request_info?: RequestInfo
}

export class RequestInfo {
    request_id?: string
    request_path?: string
    request_method?: string
}

export enum OperationEnum {
    CREATE = "CREATE",
    LOGIN = "LOGIN",
    LOGIN_ERROR = "LOGIN_ERROR",
    UPDATE = "UPDATE",
    DELETE = "DELETE",
    USE = "USE",
    FORCE_PASSWORD_CHANGE = "FORCE_PASSWORD_CHANGE",
    FORCE_MFA_CHANGE = "FORCE_MFA_CHANGE",
}